import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'order_list',
    component: () =>
      import('./List').then(config => createList(config.default)),
  },
  {
    path: 'pharmacy',
    name: 'pharmacy_order_list',
    component: () =>
      import('./PhamacyList').then(config => createList(config.default)),
  },
  {
    path: ':id',
    name: 'order_detail',
    component: () => import('./Detail'),
    props: true,
  },
]
